import React, { useState, useRef, useEffect } from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card, Badge, Spinner, Modal, ModalHeader, ModalBody,
  CardHeader, Table,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
} from "reactstrap";
import { useSelector, useDispatch } from 'react-redux'

import {
  fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
  floattest, numtest
} from '../../../helpers/validate'
import { customStyles } from '../../../helpers/mycomps'

import Select from "react-select";
import dp from "../../images/dp.jpg"



import Features from "./Features";

const modelyears = [{ value: 0, label: '2020' }, { value: 1, label: '2021' }, { value: 2, label: '2022' }, { value: 3, label: '2023' },
  , { value: 4, label: '2024' }]

function Vehiclereq(props) {
  const catlist = useSelector(state => state.featureStore.featureData).map(x => {
    return {
      label: x.categoryName.en, value: x.categoryCode,
      labelfr: x.categoryName.fr, labelar: x.categoryName.ar,
      features: x.features, unit: x.unit
    }
  })
  const [vtypeList, setVtypeList] = useState([])
  const [categories, setCategories] = useState({ categoryCode: "", en: "", fr: "", ar: "" })
  const [showProcessing, setShowProcessing] = useState(false)
  const [showdetails, setShowdetails] = useState(false)
  const [features, setFeatures] = useState({ featureCode: "", en: "", fr: "", ar: "", unit: "" })
  const [featuresList, setFeatureslist] = useState([])
  const [brandList, setBrandList] = useState([])
  const [selectedbrand, setSelectedBrand] = useState({
    bid: "", bname: { en: "", fr: "", ar: "" },
    blogo: ""
  })
  const [showvr, setShowvr] = useState(false)

  const [{ alt, src }, setImg] = useState({
    src: dp,
    alt: ''
  });

  const [filenames, setFilenames] = useState()
  const hiddenFileInput = useRef(null);
  const [vehicleList, setVehicleList] = useState([])

  const [vehicle, setVehicle] = useState({
    vid: "",
    categoryCode: "",
    category: { en: "", fr: "", ar: "" },
    bid: "",
    blogo: "",
    bname: { en: "", fr: "", ar: "" },
    mname: { en: "", fr: "", ar: "" },
    modelyear: { value: "", label: "" },
    notes: "",
    vtypeCode: "",
    vtname: { en: "", fr: "", ar: "" },
    features: [{ featureCode: "", en: "", fr: "", ar: "", unit: "", rangeid: "", rangevalueL: "", rangevalueH: "" }]
  })

  useEffect(() => {
    populatebrands()
  }, [])

  const populatebrands = () => {
    setShowProcessing(true)
    props.API.get(`tenant/getbrands`).then((res) => {
      setBrandList(res.data.map(r => {
        return {
          ...r, value: r.bid, label: r.bname.en,
          blogo: r.blogo
        }
      }))


    }).catch(function (error) {
      setShowProcessing(false)
      if (error.response.status === 401) {
        props.swal("Unauthorized, please login again.").then(t => {
          props.history.push(`/auth/login`)
        })
      } else {
        props.swal("Error getting reqyest data")
      }
      console.log(error)

    })

    props.API.get(`tenant/vehicle`).then((res) => {
      setVehicleList(res.data)

    }).catch(function (error) {
      setShowProcessing(false)
      if (error.response.status === 401) {
        props.swal("Unauthorized, please login again.").then(t => {
          props.history.push(`/auth/login`)
        })
      } else {
        props.swal("Error getting reqyest data")
      }
      console.log(error)

    })
    props.API.get(`tenant/vtypes/${"-"}`).then((res) => {

      setVtypeList(res.data)

    }).catch(function (error) {
      setShowProcessing(false)
      console.log(error)
      if (error.response.status === 401) {
        props.swal("Unauthorized, please login again.").then(t => {
          props.history.push(`/auth/login`)
        })
      } else {
        props.swal("Error getting reqyest data")
      }

    })
    setShowProcessing(false)
  }

  const cinputConfirmAlert = (xcc) => {
    let mtext = "Create"
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want " + mtext,
      icon: "warning",
      dangerMode: true,
    })
      .then(willDelete => {
        if (willDelete) {
          updvehicle()
        }
      });

  };


  const handleImg = (e) => {

    if (e.target.files[0]) {

      if (filenamevalid(e.target.files[0])) {
        setFilenames(e.target.files[0])
        setImg({
          src: URL.createObjectURL(e.target.files[0]),
          alt: e.target.files[0].name
        });
      } else {
        props.swal("Invalid Filename")
      }
    }


  }

  const updvehicle = () => {
    if (fieldvalidator(vehicle.categoryCode, vehicle.bname.en, vehicle.mname.en, vehicle.notes)) {
      props.swal("Some Required information is missing, check model.")
      return
    }

    setShowProcessing(true)
    let formData = new FormData();

    formData.append('vehicle', JSON.stringify(vehicle))
    props.API({
      method: "post",
      url: `ten/vehiclereq`,
      data: formData
    }).then((res) => {
      props.swal("Vehicle Requested!")
      setShowProcessing(false)
      props.setSvshow(false)
    }).catch(function (error) {
      setShowProcessing(false)
      if (error.response.status === 401) {
        props.swal("Unauthorized, please login again.").then(t => {
          props.history.push(`/auth/login`)
        })
      }
      console.log(error)
    })

  }

  const showTiles = () => {
    try {
      return (
        <Modal isOpen={showdetails}>
          <ModalHeader toggle={() => setShowdetails(!showdetails)}>

          </ModalHeader>
          <ModalBody>


            <Row>
              <Col><h6>{vehicle.bname.en}</h6> </Col>
              <Col>{vehicle.vtname.en}</Col>
              <Col><h6 style={{ float: "right" }}>{vehicle.bname.ar}</h6></Col>
            </Row>

            <Row>
              <Col>
                <label>{vehicle.mname.en}</label>
              </Col>
              <Col>
                <center><label>{vehicle.modelyear.label}</label></center>
              </Col>
              <Col>  <label style={{ float: "right" }}>{vehicle.mname.ar}</label></Col>
            </Row>
            <Row>
              <Col style={{ textAlign: "center" }}>
                {vehicle.notes}
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                {vehicle.features.map(f => {
                  if (f.featureCode !== "") {
                    return (
                      <p style={{ fontSize: "0.8rem" }}>- {f.en} : {f.rangevalueL === f.rangevalueH ? <span style={{ float: "right" }}>{f.rangevalueL}</span> : <span style={{ float: "right" }}>{f.rangevalueL} - {f.rangevalueH}</span>}  </p>
                    )
                  }

                })}
              </Col>
            </Row>


          </ModalBody>
        </Modal>

      )
    } catch (e) {
      return (
        <h6 style={{ textAlign: "center" }}>Please refresh list...</h6>
      )
    }

  }

  const valueRange = () => {

    return (
      <Modal isOpen={showvr}>
        <ModalHeader toggle={() => setShowvr(!showvr)}>{features.featureCode}-{features.en}
        </ModalHeader>
        <ModalBody>

          <Row>
            <Col>
              <Table style={{ fontSize: "1rem" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>#</th>
                    <th style={{ textAlign: "center" }}>Min</th>
                    {/** <th>Higher</th> */}
                    <th style={{ textAlign: "center" }}>Max</th>
                    <th ></th>

                  </tr>
                </thead>
                <tbody>
                  {
                    showfvrl()
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    )

  }

  const showfvrl = () => {
    try {

      return (
        features.valueRange.map((e, key) => {
          return (
            <tr id={key}>
              <td style={{ textAlign: "center" }}>{e.vrid}</td>
              <td style={{ textAlign: "center" }}>{e.len}</td>
              <td style={{ textAlign: "center" }}>{e.hen}</td>
              <td style={{ textAlign: "center" }}>
                <div className="actions-right">

                  <Button
                    onClick={() => {
                      let obj = features.valueRange.find((o) => o.vrid === e.vrid);

                      if (Features.featureCode !== "") {
                        setVehicle({
                          ...vehicle, features: [...vehicle.features, {
                            featureCode: features.featureCode, en: features.en, fr: features.fr, ar: features.ar,
                            unit: features.unit, rangeid: obj.vrid, rangevalueL: obj.len, rangevalueH: obj.hen
                          }]
                        })
                      }
                      setShowvr(false)
                    }}
                    color="danger"
                    size="sm"
                    className="btn-icon btn-link remove"
                  >
                    <i className="fa fa-crosshairs" aria-hidden="true"></i>
                  </Button>{" "}
                </div>

              </td>

            </tr>
          )
        })
      )
    } catch (e) {

    }

  }

  useEffect(() => {
    // setSelectedBrand({value : props.vehicle.bid, value : props.vehicle.bname.en})
    setVehicle(props.vehicle)
  }, [props.vehicle])


  return (

    <div className="content">

      {valueRange()}
      <input
        ref={hiddenFileInput}
        type="file"
        accept=".png, .jpg, .jpeg"
        id="photo"
        className="visually-hidden"
        onChange={e => handleImg(e)}
        hidden />
      {showTiles()}

      <Row>
        {/** This will contain Table */}
        <Col sm="12" md="12">
          {showProcessing ? <center><Spinner /></center> :

            <Card>

              <CardBody>
                <Row>
                  <Col sm="12" md="6">
                    <FormGroup>
                      <label>Select Catagory </label>
                      <Select options={catlist} styles={customStyles}
                        value={props.vehicle.categoryCode !== "" ? { label: props.vehicle.category.en + ' ' + props.vehicle.category.ar, value: props.vehicle.categoryCode } : { label: categories.en + ' ' + categories.ar, value: categories.categoryCode }}
                        onChange={e => {
                          setCategories({ categoryCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar });
                          setFeatureslist(e.features.map(t => {
                            return {
                              ...t, value: t.featureCode, label: t.en, labelfr: t.fr, labelar: t.ar, unit: t.unit
                            }
                          }));
                          setFeatures({ featureCode: "", en: "", fr: "", ar: "", unit: "" })
                          setVehicle({ ...vehicle, categoryCode: e.value, category: { en: e.label, fr: e.labelfr, ar: e.labelar } })

                        }}

                      />

                    </FormGroup>

                  </Col>
                  <Col sm="12" md="6">
                    <FormGroup>
                      <label>Select Brand {selectedbrand.bname.en !== "" && " Code : " + selectedbrand.bid}</label>

                      <Select options={brandList} styles={customStyles}
                        value={props.vehicle.bid !== "" ? { value: props.vehicle.bid, label: props.vehicle.bname.en } : { label: selectedbrand.bname.en + ' ' + selectedbrand.bname.ar, value: selectedbrand.bname.bid }}
                        onChange={e => {
                          setSelectedBrand({ bid: e.bid, bname: e.bname, blogo: e.blogo });
                          setImg({ src: `${e.blogo}` })
                          setVehicle({ ...vehicle, bid: e.bid, blogo: e.blogo, bname: e.bname })
                        }}
                      />

                    </FormGroup>

                  </Col>
                </Row>
                <Row>
                  <Col><u>Model Details</u></Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="6">
                    <FormGroup>
                      <label>Name EN</label>
                      <Input
                        value={vehicle.mname.en}
                        placeholder="en"
                        type="text"
                        onChange={e => {
                          setVehicle({ ...vehicle, mname: { ...vehicle.mname, en: e.target.value } })
                        }
                        }

                      />
                    </FormGroup>
                  </Col>{/** 
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                           value = {vehicle.mname.fr}
                             placeholder="Nom"
                             type="text"
                             onChange={e => {
                                setVehicle({...vehicle, mname : {...vehicle.mname , fr : e.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>*/}
                  <Col className="pr-1" md="6">
                    <FormGroup>
                      <label>اسم</label>
                      <Input
                        value={vehicle.mname.ar}
                        placeholder="اسم"
                        type="text"
                        onChange={e => {
                          setVehicle({ ...vehicle, mname: { ...vehicle.mname, ar: e.target.value } })
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="12">
                    <FormGroup>
                      <label>Specification</label>
                      <Input
                        value={vehicle.notes}
                        placeholder="en"
                        type="text"
                        onChange={t => {
                          setVehicle({ ...vehicle, notes: t.target.value })
                        }
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>

              </CardBody>
              <CardFooter>

                <Button size="sm" color="warning" style={{ float: "right", display: props.vehicle.reqid !== "" ? "none" : "block" }} onClick={x => {
                  cinputConfirmAlert()
                }}>Request</Button>
              </CardFooter>
            </Card>}
        </Col>

      </Row>
    </div>
  )
}

export default Vehiclereq;